export default "__VITE_ASSET__BghFXIjp__"